import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';

import { useAuth } from '../../context/AuthContext';
import { CustomerInformationWithPropertyPage } from '../../modules/ComponentsLibrary/CustomerInformation/CustomerInformationWithPropertyPage';
import { PropertyInfo } from '../../modules/PropertyInformation/components/PropertyInfo';

export const Route = createFileRoute('/properties/$propertyId')({
  component: RouteComponent,
  params: z.object({
    propertyId: z.coerce.number().positive(),
  }),
});

function RouteComponent() {
  const { propertyId } = Route.useParams();
  const { user } = useAuth();

  if (!user.preferAdminView) {
    return <Navigate to="/property-details/$propertyId" params={{ propertyId }} replace />;
  }

  return (
    <>
      <CustomerInformationWithPropertyPage />
      <PropertyInfo propertyId={propertyId} />
    </>
  );
}
